var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audience-overview-chart p-4 rounded-lg shadow-sm bg-white"},[_c('div',{staticClass:"flex items-center justify-end mb-2"},[_c('ChartSelect',{model:{value:(_vm.yAxisField),callback:function ($$v) {_vm.yAxisField=$$v},expression:"yAxisField"}})],1),_c('div',{staticClass:"chart-container mb-6"},[_c('EchartCon',{attrs:{"data":_vm.chartData,"yAxisField":_vm.yAxisField}})],1),_c('CommonTable',{attrs:{"table-data":_vm.tableData,"name-column-props":{
      prop: 'name',
      label: '受众群体名称',
      width: '160px',
    },"show-status":true,"currency":_vm.currency}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }